import React from 'react';
import ReloadButton from '../../../../features/ReloadButton/ReloadButton';
import { ButtonPest } from '../../../../utils/Button';
import { InputFieldSearch, SelectOption, addOption } from '../../../../utils/InputField';
import { useProductSetting } from '../ProductSettingProvider';

function PageHeaderLeftCol({ setProductFilter, productFilter }) {
    const handleOnChange = (e) => {
        const { name, value } = e.target;
        if (name) {
            setProductFilter((prev) => ({ ...prev, [name]: value }));
        }
    };

    return (
        <form className="page_header_left_col flex-1 flex items-center gap-x-3">
            <InputFieldSearch
                label="Search Products"
                name="searchValue"
                formData={productFilter || ''}
                onChange={handleOnChange}
                className="w-68"
            />
            <SelectOption
                placeholder="status"
                name="status"
                formData={productFilter || ''}
                onChange={handleOnChange}
                options={['active', 'inactive'].map((item) => addOption(item, item, item))}
                className="w-40"
            />
        </form>
    );
}

function ProductListHeader() {
    const { handleReload, handleShowCreateModal, productFilter, setProductFilter } =
        useProductSetting();

    return (
        <div className="app_page_header w-full mb-7 flex flex-row gap-2 justify-end items-center">
            <PageHeaderLeftCol setProductFilter={setProductFilter} productFilter={productFilter} />
            <div className="flex flex-row gap-2 items-center">
                <ButtonPest
                    btnType="button"
                    title="+ Add Product"
                    onClick={handleShowCreateModal}
                />
                <div>
                    <ReloadButton height="h-10" width="w-10" onClick={handleReload} />
                </div>
            </div>
        </div>
    );
}

export default ProductListHeader;
